import type {ReactNode, Ref} from 'react'
import {cn} from '@/lib/utils'

interface DropZoneProps {
    children: ReactNode
    /** Whether a draggable is hovering over this zone (activates highlight). */
    active?: boolean
    /** Ref to pass to the underlying `<div>` — e.g. `useDroppable()`'s `setNodeRef`. */
    innerRef?: Ref<HTMLDivElement>
    className?: string
    'data-testid'?: string
}

/**
 * Dashed-border drop zone for drag-and-drop interfaces. Renders a min-height
 * container that highlights in primary colour when a draggable hovers over it.
 */
export function DropZone({children, active, innerRef, className, 'data-testid': testId}: DropZoneProps) {
    return (
        <div
            ref={innerRef}
            className={cn(
                'min-h-[200px] rounded-lg border-2 border-dashed transition-colors',
                active ? 'border-primary bg-primary/5' : 'border-muted-foreground/20',
                className,
            )}
            data-testid={testId}
        >
            {children}
        </div>
    )
}
